import { type TipType } from './shift-tips-modal.types';
import type { ShiftTipRolePeriod } from 'shared-models';

const roleClock=new Intl.DateTimeFormat('he-IL',{timeZone:'Asia/Jerusalem',hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
export function rolePeriodLabel(period:ShiftTipRolePeriod):string {
  const start=roleClock.format(new Date(period.startShiftAt));
  const end=period.endShiftAt ? roleClock.format(new Date(period.endShiftAt)) : '-';
  return `${period.employeeName} ${start} - ${end}`;
}

export const sections: Array<{ type: TipType; label: string }> = [
  { type: 'daily', label: 'יומי' },
  { type: 'morning', label: 'בוקר' },
  { type: 'evening', label: 'ערב' },
];

